export default "__VITE_ASSET__Bzlm2KDS__"